<script setup>
import { decoratorProps } from '@/mixin/props'
import { defineProps, defineEmits } from 'vue'

defineEmits(decoratorProps.emits)
defineProps({
  ...decoratorProps.props
})
</script>
<template>
  <div>
    <slot name="content" />
  </div>
</template>
